import * as React from 'react';

import {GlanceData, Partner, Region, StudioAppConfig} from 'glance-datatypes';

import RestService from '../RestService';
import Utils from '../Utils';
import { connect } from 'react-redux';

const styles = {
    image : {
        padding: '5px',
        width: 'auto',
        margin: '5px auto',
        boxShadow: 'rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px',
        backgroundColor: 'rgb(255, 255, 255)',
        display: 'block',
    },
    tagline : {
        color: '#aaaaaa',
    },
    peekData : {
        width:'50em',
        margin: 'auto',
        display: 'block',
    },
    summary : {
        width:'50em',
        margin: 'auto',
        display: 'block',
    },
};

enum ApprovalState {
    APPROVING, APPROVED, REJECTING, REJECTED,
}

interface Props {
    params: any;
    studioAppConfig: StudioAppConfig;
    partnerMap: Map<string, Partner>;
}

interface State {
    approvalState: ApprovalState;
    error?: string;
    glanceId: string;
    data?: GlanceData;
}

class Approval extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        const glanceId = this.props.params.id;
        let state : ApprovalState;
        let error: string;
        if (this.props.params.action == 'approve') {
            state = ApprovalState.APPROVING;
        } else if ((this.props.params.action == 'reject')) {
            state = ApprovalState.REJECTING;
        } else {
            error = 'Malformed URL. Contact Glance support if persists.';
        }

        this.state = {
            approvalState: state,
            error: error,
            glanceId: glanceId,
        };
    }

    componentDidMount() {
        let that = this;
        let partner: Partner;
        if (this.props.params && this.props.params.partnerId) {
            partner = this.props.partnerMap.get(this.props.params.partnerId);
        } else if (this.props.partnerMap.size > 0) {
            partner = this.props.partnerMap.values().next().value;
        } else {
            partner = this.props.studioAppConfig.currentToken.partner;
        }
        if (this.state.approvalState == ApprovalState.APPROVING) {
            RestService.approveGlance(Region.IN, that.state.glanceId, partner, (data) => {
                if (data) {
                    that.setState({
                        ...that.state,
                        data: data,
                        approvalState: ApprovalState.APPROVED,
                    });
                } else {
                    that.setState({
                        ...that.state,
                        error: 'Unable to approve glance, contact Glance support.',
                    });
                }
            });
        } else if (this.state.approvalState == ApprovalState.REJECTING) {
            RestService.rejectGlance(Region.IN, that.state.glanceId, partner, (data) => {
                if (data) {
                    that.setState({
                        ...that.state,
                        data: data,
                        approvalState: ApprovalState.REJECTED,
                    });
                } else {
                    that.setState({
                        ...that.state,
                        error: 'Unable to reject glance, contact Glance support.',
                    });
                }
            });
        }
    }

    render() {
        let message: string;

        if (this.state.error) {
            message = this.state.error;
        } else {
            switch (this.state.approvalState) {
                case ApprovalState.APPROVING:
                    message = 'Approving glance ...';
                    break;
                case ApprovalState.APPROVED:
                    message = 'Glance approved.';
                    break;
                case ApprovalState.REJECTING:
                    message = 'Rejecting glance ...';
                    break;
                case ApprovalState.REJECTED:
                    message = 'Glance rejected.';
                    break;
            }
        }

        const elements = [];

        elements.push(
            <h1 style={{textAlign:'center'}} key='message'>
                {
                    message
                }
            </h1>,
        );

        if (this.state.data) {
            const imageUrl = this.props.studioAppConfig.cdnPrefix + 'wallpaper/' + this.state.data.image.id + '.webp';
            const tagline = this.state.data.peekData ? this.state.data.peekData.title : null;
            const peekLink = Utils.getPeekLink(this.state.data);
            const summary = Utils.getSummary(this.state.data);
            elements.push(
                <img key='image' id='image' style={styles.image} width='225px' height='400px' src={imageUrl}/>,
            );
            elements.push(
                <div key='peekData' style={styles.peekData}>
                    <span className='tagline' style={styles.tagline}>Tagline: </span>{tagline}
                    <br/>
                    <span className='tagline' style={styles.tagline}>PeekLink: </span> <a href={peekLink} target='_blank'>{peekLink}</a>
                </div>,
                <div key='summary' style={styles.summary}>
                    <span className='tagline' style={styles.tagline}>Summary: </span> {summary}
                </div>,
            );
        }

        return (
            <div style={{textAlign: 'center'}}>
                {
                    elements
                }
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        studioAppConfig: state.studioAppConfig,
    };
};


export default connect(mapStateToProps)(Approval);




// WEBPACK FOOTER //
// ./src/components/Approval.tsx